import { render } from "./rightDrawer.vue?vue&type=template&id=2737c84b"
import script from "./rightDrawer.vue?vue&type=script&lang=js"
export * from "./rightDrawer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__